import { get } from 'lodash';
import i18next from 'i18next';
import React from 'react';

import { InpulseLabel } from '@commons/DeepsightComponents';
import { labelContainerStyle } from '@commons/constants/labelStyle';

import { LabelContainer } from '../styledComponents';

const renderLabel = (item) => (
  <div className="supplier-label-render" style={labelContainerStyle}>
    <InpulseLabel
      color={item === 'Actif' ? 'green' : item === 'Inactif' ? 'red' : 'black'}
      text={String(item)}
    />
  </div>
);

export const getColumnsSettings = (translatedStoresName) => [
  {
    id: 'store_name',
    name: i18next.t('GENERAL.NAME'),
    displayName: i18next.t('GENERAL.NAME'),
    propertyKey: 'name',
    baseName: 'name',
  },
  {
    id: 'brand-name',
    name: i18next.t('BACKOFFICE.CHECKS.EXPORT_MODAL_LABEL_BRAND'),
    displayName: 'brandName',
    baseName: 'brandName',
    propertyKey: 'brandName',
  },
  {
    id: 'identifier',
    name: i18next.t('ORDERS.ORDERS.LIST_LABEL_IDENTIFIER'),
    displayName: i18next.t('ORDERS.ORDERS.LIST_LABEL_IDENTIFIER'),
    propertyKey: 'partnerId',
    baseName: 'partnerId',
  },
  {
    id: 'status',
    name: i18next.t('ORDERS.ORDERS.LIST_LABEL_STATUS'),
    displayName: i18next.t('ORDERS.ORDERS.LIST_LABEL_STATUS'),
    propertyKey: 'active',
    baseName: 'active',
    excludeFromSearch: true,
    list: [
      {
        id: 'active',
        value: 'Actif',
        active: 'Actif',
        propertyKey: 'active',
        name: 'Actif',
        render: (item) => (
          <div className="supplier-label-render">
            <InpulseLabel color="green" text={item.name} />
          </div>
        ),
      },
      {
        id: 'inactive',
        value: 'Inactif',
        active: 'Inactif',
        name: 'Inactif',
        propertyKey: 'active',
        excludeFromSearch: true,
        render: (item) => (
          <div className="supplier-label-render">
            <InpulseLabel color="red" text={item.name} />
          </div>
        ),
      },
    ],
    render: (it) => renderLabel(it),
  },
  {
    id: 'number-of-associated-stores',
    name: i18next.t('BACKOFFICE.CASHIER_STORES.ASSOCIATED_CASHIER_STORES', {
      storeName: translatedStoresName,
    }),
    propertyKey: 'mappedCashierStores',
    render: (item) => (
      <LabelContainer>
        <InpulseLabel
          color={get(item, 'length', 0) > 0 ? 'green' : 'red'}
          text={String(get(item, 'length', 0))}
        />
      </LabelContainer>
    ),
  },
];

export default {
  getColumnsSettings,
};
